import React from 'react';

export default function BottomNavItem({ icon, label, active, disabled, onClick }) {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    } else {
      e.preventDefault();
    }
  };

  return (
    <button
      type="button"
      className={`bottom-nav-item ${active ? 'bottom-nav-item--active' : ''} ${disabled ? 'bottom-nav-item--disabled' : ''}`}
      onClick={handleClick}
      disabled={disabled}
    >
      <span className="material-symbols-outlined">{icon}</span>
      <span>{label}</span>
    </button>
  );
}
